<template>
  <div class="home">
    <!-- 标题栏 -->
    <div class="header">
      <h1>臻选礼诚</h1>
    </div>

    <!-- 图片列表 -->
    <div class="image-list">
      <div v-for="(card, index) in cards" :key="index" class="image-item" @click="goToCardDetail(card.cardTypeId, card.cardName)">
        <div class="image-container">
          <img :src="card.cardPicUrl" :alt="card.cardName" class="image" />
        </div>
      </div>
    </div>

    <div class="exchange-instructions">
      <h2>兑换说明</h2>
      <p>1. 点击礼品券，可进入兑换页面。</p>
      <p>2. 请在有效期内完成兑换。</p>
      <p>2. 每个礼品券仅限使用一次。</p>
      <p>3. 如有问题，请联系客服: 19941356990。</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import axios from 'axios'; 
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import MarqueeBox from '@/components/Marquee.vue';

interface ApiResponse {
  msg: string;
  code: number;
  data: {
    isSuccess: boolean;
    msg: string;
    data: GiftCard[];
  };
}

interface GiftCard {
  cardName: string;
  cardPicUrl: string;
  cardTypeId: string;
  expireDate: string;
  isValid: boolean;
  startDate: string;
}

@Options({
  components: {
    HelloWorld,
    MarqueeBox
  },
})
export default class HomeView extends Vue {
  cards: GiftCard[] = [];// 图片数据

  apiUrl = process.env.VUE_APP_API_BASE_URL;
  

  async created() {
    // 在组件创建时调用 API 获取图片数据
    try {
      const response = await axios.get<ApiResponse>(this.apiUrl + '/gift-card-type/query/all'); // 替换为你的 API 地址
      this.cards = response.data.data.data; // 假设 API 返回的数据格式为 [{ url: 'image1.jpg' }, { url: 'image2.jpg' }]
    } catch (error) {
      console.error('Failed to fetch images:', error);
    }
  }

  // 跳转到卡片详情页
  goToCardDetail(cardTypeId: string, cardName: string) {
    this.$router.push({
      path: '/card-detail',
      query: { cardTypeId, cardName }, // 传递 cardTypeId 和 cardName
    });
  }
}
</script>

<style scoped>
.home {
  /* 定义一个从顶部到底部的红色渐变 */
  background: linear-gradient(to bottom,#ff3b3b, #ff7e7e); /* 从亮红到暗红 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header h1 {
  color: white; /* 设置标题文字为白色 */
  margin-bottom: 20px; /* 添加底部外边距 */
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* 设置卡片之间的间距 */
  justify-content: center;
}

.image-item {
  /* 移除白色背景 */
  /* background: white; */
  border-radius: 8px; /* 圆角 */
  padding: 0; /* 移除 padding */
  width: 100%;
  margin: 10px 10px 0px; /* 减少 margin */
  text-align: center;
  overflow: hidden;
}

.image-container {
  position: relative;
  margin: 0 auto; /* 居中 */
  width: 100%; /* 宽度为屏幕宽度减去左右各 20px */
}

.image {
  width: 100%; /* 图片宽度占满容器 */
  height: auto; /* 高度自适应 */
  border-radius: 4px;
  object-fit: cover; /* 保持图片比例，裁剪多余部分 */
}

.exchange-instructions {
  padding: 16px;
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影 */
  width: 100%;
  max-width: 800px; /* 设置最大宽度 */
  margin-top: 20px; /* 与图片列表的间距 */
}

.exchange-instructions h2 {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: bold; 
  color: white;
  text-align: center;
}

.exchange-instructions p {
  margin: 4px 0;
  font-size: 14px;
  font-weight: bold; 
  color: white;
  text-align: left;
  margin-left: 20px;
}
</style>